module.exports = __webpack_public_path__ + "media/img/about-us/values-img-a4175a20eec775f77dfe36dafcd7926b.jpg";